import * as pixi from "pixi.js";

export { pixi };